import { createFileRoute } from '@tanstack/react-router';
import { NotificationSettingsPage } from '../../components/settings/notification-settings-page.js';

export const Route = createFileRoute('/settings/notifications')({
  component: NotificationSettingsPage,
});
